import BaseRestApi from '@/services/BaseRestApi';
import RestErreur from '@/utils/RestErreur';
import CoursDto from '@/models/titre/CoursDto';

export default class TitreRestApi extends BaseRestApi {
  get resource() { // eslint-disable-line
    return '/titre';
  }

  async getTauxChange(iniAnnee, insCurrency) {
    try {
      const dateActuelle = new Date();
      const anneeActuelle = dateActuelle.getFullYear();

      let anneeATauxUtiliser;

      // - Si l'année de calcul est échue (31/12 passé) -> prendre le taux de l'année de calcul
      // - Sinon -> prendre le taux N-1
      if (iniAnnee < anneeActuelle) {
        // L'année de calcul est échue (31/12 inclus)
        anneeATauxUtiliser = iniAnnee;
      } else {
        // L'année de calcul n'est pas échue
        anneeATauxUtiliser = iniAnnee - 1;
      }

      const coAnswer = await this.getApi().get(`${this.resource}/coursAnnuel/${anneeATauxUtiliser}/${insCurrency}`);
      const ciStatus = coAnswer.status;

      if (ciStatus === 200) {
        if (coAnswer.data) {
          const dtoCours = CoursDto.getFactory(coAnswer.data);
          return dtoCours.valeurCloture;
        }
        return new RestErreur('Pas de taux de change pour pour cette année', coAnswer);
      }
      return new RestErreur('TitreRestApi:getTauxChange() warning', coAnswer);
    } catch (inexError) {
      return new RestErreur('TitreRestApi:getTauxChange() erreur', inexError);
    }
  }
}
